import { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";

import { RequireRole } from "@/routes/RequireRole";
import { LandingPage } from "@/pages/LandingPage";
import { HomePage } from "@/pages/HomePage";
import { LoginPage } from "@/pages/LoginPage";
import { KioskLoginPage } from "@/pages/KioskLoginPage";
import { OnboardingPage } from "@/pages/OnboardingPage";
import { KioskPage } from "@/pages/kiosk/KioskPage";
import { AdminDashboard } from "@/pages/admin/AdminDashboard";
import { DownloadPage } from "@/pages/public/DownloadPage";
import { getFirebaseAuth } from "@/lib/firebase";

// Universal logout - not exposed in UI, navigate to /logout manually
function LogoutPage() {
  const navigate = useNavigate();
  useEffect(() => {
    signOut(getFirebaseAuth()).finally(() => navigate("/", { replace: true }));
  }, [navigate]);
  return null;
}

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/kiosk/login" element={<KioskLoginPage />} />

      {/* Post-login home (redirects to role dashboard) */}
      <Route path="/home" element={<HomePage />} />

      {/* Role-protected routes */}
      <Route
        path="/kiosk/*"
        element={
          <RequireRole role="kioskconsumer">
            <KioskPage />
          </RequireRole>
        }
      />
      {/* Unified dashboard for admins and creators */}
      <Route
        path="/dashboard/*"
        element={
          <RequireRole role={["imagepackcreator", "admin"]}>
            <AdminDashboard />
          </RequireRole>
        }
      />
      {/* Legacy routes redirect to unified dashboard */}
      <Route
        path="/admin/*"
        element={
          <RequireRole role={["imagepackcreator", "admin"]}>
            <AdminDashboard />
          </RequireRole>
        }
      />
      <Route
        path="/creator/*"
        element={
          <RequireRole role={["imagepackcreator", "admin"]}>
            <AdminDashboard />
          </RequireRole>
        }
      />

      {/* Public download page (UUID routes) */}
      <Route path="/:downloadId" element={<DownloadPage />} />
    </Routes>
  );
}
